'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.PopupTrigger = void 0;
(function (PopupTrigger) {
    /**
     * Describes the 'click' event which triggers the action.
     */
    PopupTrigger["CLICK"] = "click";
    /**
     * Describes the 'hover' event which triggers the action.
     */
    PopupTrigger["HOVER"] = "hover";
})(exports.PopupTrigger || (exports.PopupTrigger = {}));
//# sourceMappingURL=Popup.types.js.map
